export default "__VITE_PUBLIC_ASSET__f190dc2e__"